/**
 * @file: useHasProducts.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { useCurrentStoreId } from '@euler/app/flows/auth/context';
import { useAsyncStorage } from '@euler/functions/useAsyncStorage';
import { useServiceFactory } from '@euler/services/factory';
import { useCallback, useEffect, useRef } from 'react';

export const useHasProducts = () => {
  const { productService } = useServiceFactory();
  const storeId = useCurrentStoreId();
  const [hasProducts, setHasProducts] = useAsyncStorage(
    `${storeId}_has-products`,
    false,
  );
  const hasProductsRef = useRef(hasProducts);
  hasProductsRef.current = hasProducts;

  const refresh = useCallback(() => {
    productService
      .hasProducts()
      .then(value => {
        if (hasProductsRef.current !== value) {
          setHasProducts(value);
          hasProductsRef.current = value;
        }
      })
      .catch(console.error);
  }, [productService, setHasProducts]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return [hasProducts ?? false, refresh] as const;
};
